/**
 * Sign-up page
 * initial it by passing sign-up form ID
 **/
import Signup from '../components/signupHandler';

let cacoo = require('../components/cacoo').cacoo;

export default class InvitationSignup extends Signup {

  attachEvent() {
    this.fullName.on('focusout', () => {
      this.nameValidate();
      if (cacoo.util.validateEmail(this.fullName.val())) {
        this.formMessageHandler.showError('name', Cacoo.SiteResources['modal_signup_name_error']);
      }
    });

    this.password.on('focusout', () => {
      this.passwordValidate();
    });

    //Only for Japanese version
    if (this.tos.length > 0) {
      this.tos.on('click', () => {
        this.tosError.hide();
      });
    }
  }

  finalValidate() {
    this.nameValidate();
    this.passwordValidate();
    this.tosValidate();

    if (!this.fullName.hasClass("is_success") ||
        !this.password.hasClass("is_success") ||
        (this.tos.length > 0 && !this.tos.is(":checked"))
    ) {
      return false;

    }
    return true
  }

}
